/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Fragment, useMemo } from "react";
import StickyToolCss from "components/stickyTools/StickyTools.css";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import PropTypes from "prop-types";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";
import Icon from "@react/react-spectrum/Icon";
import { isFunction } from "utils/APIUtils";
import { isIOSDevice } from "utils/AppUtils";
import { isCurrentDeviceMobile } from "dc-preview-utils/src/Utils/DeviceUtils";
import classNames from "classnames";

const StickyToolItem = props => {
  const { verbName, verbDetail, stickyToolsClickHelper } = props;
  const { icon, label, disabled, relatedTools = [] } = verbDetail || {};
  let stickyItemStyle;
  const StickyToolIcon = useMemo(
    () =>
      isFunction(icon) ? (
        <CustomIcon url={icon} size="M" className={StickyToolCss.stickyIcon} />
      ) : (
        <Icon size="M" className={StickyToolCss.stickyIcon}>
          {icon}
        </Icon>
      ),
    [icon]
  );

  if (isIOSDevice()) {
    stickyItemStyle = {
      paddingBottom: "12px"
    };
  }

  let className = StickyToolCss.StickyTabItemContainer;
  if (!isCurrentDeviceMobile()) {
    className = classNames(className, StickyToolCss.StickyMarginTablet);
  }

  const stickyItem = (
    <div className={StickyToolCss.stickyItem} style={stickyItemStyle}>
      {StickyToolIcon}
      <span> {label} </span>
    </div>
  );

  return (
    <Fragment>
      <div className={className}>
        <ButtonWrapper
          id={verbName}
          clickHandler={stickyToolsClickHelper}
          buttonClass={StickyToolCss.stickyButton}
          shouldDisable={disabled}
          shouldDisableTooltip
          tooltipString="-"
          holdAffordance={!!relatedTools.length}
        >
          {stickyItem}
        </ButtonWrapper>
      </div>
    </Fragment>
  );
};

StickyToolItem.propTypes = {
  verbName: PropTypes.string,
  verbDetail: PropTypes.shape({
    icon: PropTypes.func,
    initialized: PropTypes.bool,
    label: PropTypes.string,
    type: PropTypes.string,
    verbId: PropTypes.string,
    relatedTools: PropTypes.array
  }),
  stickyToolsClickHelper: PropTypes.func
};

StickyToolItem.defaultProps = {
  verbName: PropTypes.string,
  verbDetail: {},
  stickyToolsClickHelper: () => {}
};

export default StickyToolItem;
